<div class="fund-overview">
  <!-- Header Section with Welcome Message and Fund Switcher -->
  <div class="fund-overview__header">
    <div class="fund-overview__welcome">
      <h2 class="fund-overview__welcome-text">
        {{ welcomeMessage() | translateLang: { name: userName() } }}
      </h2>
    </div>
    <div class="fund-overview__fund-switcher">
      <app-fund-switcher
        [funds]="funds()"
        [selectedFundId]="selectedFundId()"
        [placeholder]="fundSwitcherPlaceholder()"
        [numberFormat]="numberFormat()"
        (fundChanged)="onFundChanged($event)"
      >
      </app-fund-switcher>
    </div>
  </div>

  <!-- Balance Information Container -->
  <div class="fund-overview__balance-container">
    <div class="fund-overview__balance-content">
      <!-- Left Side: Total Balance with Icon -->
      <div class="fund-overview__total-balance">
        <div class="fund-overview__icon-container">
          <img
            class="fund-overview__icon"
            src="/assets/images/icons/wallet-icon.svg"
            alt="Wallet icon"
          />
        </div>
        <div class="fund-overview__balance-info">
          <p class="fund-overview__balance-label">
            {{ 'fund.total_balance' | translateLang }}
          </p>
          <div class="fund-overview__balance-amount">
            <span class="fund-overview__balance-value">{{ formattedTotalBalance() }}</span>
            @if (!isLoading() || balanceInfo().totalBalance > 0) {
            <app-currency-indicator
              [currencyCode]="balanceInfo().currencyCode"
              [countryCode]="balanceInfo().countryCode"
              variant="white"
            >
            </app-currency-indicator>
            }
          </div>
        </div>
      </div>

      <!-- Right Side: Available Balance -->
      <div class="fund-overview__available-balance">
        <p class="fund-overview__balance-label">
          {{ 'fund.available_balance' | translateLang }}
        </p>
        <p class="fund-overview__available-value">{{ formattedAvailableBalance() }}</p>
      </div>
    </div>
  </div>

  <!-- Timestamp Footer -->
  <div class="fund-overview__footer">
    <div class="fund-overview__timestamp">
      <svg
        class="fund-overview__timestamp-icon"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.33333 1.33333V4"
          stroke="#FFE2E2"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.6667 1.33333V4"
          stroke="#FFE2E2"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.6667 2.66667H3.33333C2.59695 2.66667 2 3.26362 2 4V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V4C14 3.26362 13.403 2.66667 12.6667 2.66667Z"
          stroke="#FFE2E2"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 6.66667H14"
          stroke="#FFE2E2"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="fund-overview__timestamp-text"
        >{{ 'fund.as_of' | translateLang }} {{ formattedTimestamp() }}</span
      >
    </div>
  </div>
</div>
